export default {
  processing: 'Procesando consulta',
};
